import { render, staticRenderFns } from "./OvertimeBreakdownDetailsText.vue?vue&type=template&id=57f3b2ea"
import script from "./OvertimeBreakdownDetailsText.vue?vue&type=script&lang=js"
export * from "./OvertimeBreakdownDetailsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports